var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDataValue, removeDataValue } from '@juvare/json-data-util';
import React from 'react';
import { QuickAdvancedSearch } from '../components/QuickAdvancedSearch';
export function quickAdvancedSearchFilter(params) {
    return {
        quickFilter: {
            render: (props) => React.createElement(QuickAdvancedSearch, Object.assign({}, props, params)),
            dataPath: params.search.dataPath,
        },
        widgetConfig: {
            type: 'form.text',
            key: params.search.dataPath,
            label: params.search.label,
        },
        getFilterChips: (filterData) => __awaiter(this, void 0, void 0, function* () {
            const { search, advancedSearch } = params;
            const simpleValue = getDataValue(filterData, search.dataPath);
            const advancedValues = getDataValue(filterData, advancedSearch.dataPath);
            const chips = [];
            if (simpleValue && typeof simpleValue === 'string') {
                chips.push({
                    label: simpleValue,
                    onRemoveChip: (chipFilterData) => handleRemoveChip(chipFilterData, params.search.dataPath),
                    groupId: params.search.dataPath,
                });
            }
            if (Array.isArray(advancedValues) && advancedValues.length) {
                for (const [idx, advancedValue] of advancedValues.entries()) {
                    const fieldValue = advancedSearch.field.options.find((fieldOption) => fieldOption.value === advancedValue[advancedSearch.field.dataPath]);
                    const operatorValue = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.operatorOptions.find((operatorOption) => operatorOption.value === advancedValue[advancedSearch.operator.dataPath]);
                    const searchValue = advancedValue[advancedSearch.value.dataPath];
                    if ((fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.label) && (operatorValue === null || operatorValue === void 0 ? void 0 : operatorValue.label) && searchValue) {
                        // the following logic ensures that if this is the last applied advanced filter
                        // it deletes dataPath altogether. Otherwise, <ChipBar /> sees advanced search dataPath key
                        // in dataFilter object and renders it, albeit empty, leaving unwanted UI behaviour.
                        let filterIndex = `.#${idx}`;
                        if (advancedValues.length === 1) {
                            filterIndex = '';
                        }
                        chips.push({
                            label: `${fieldValue.label} ${operatorValue.label} "${searchValue}"`,
                            onRemoveChip: (chipFilterData) => handleRemoveChip(chipFilterData, `${advancedSearch.dataPath}${filterIndex}`),
                            groupId: advancedSearch.dataPath + '.' + fieldValue.value,
                        });
                    }
                }
            }
            return chips;
        }),
    };
}
function handleRemoveChip(filterData, dataPath) {
    const newFilterData = JSON.parse(JSON.stringify(filterData));
    removeDataValue(newFilterData, dataPath);
    return newFilterData;
}
